import styled from 'styled-components';
import { mapBoxPropValues, generateBoxPropStyleRow } from '../../../Box/utils.js';
import { boxStyles } from '../../../Box/styles.js';
import { px2rem } from '../../helpers/style.js';
import { boxStyledOptions } from '../../helpers/styled.js';

var cssValueToString = function cssValueToString(cssValue) {
  return typeof cssValue === 'number' ? px2rem(cssValue) : cssValue;
};
var FloatWrapper = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__FloatWrapper",
  componentId: "sc-1ro829y-0"
})(["", ";", ";"], function (props) {
  if (!props.$isIE) {
    return mapBoxPropValues(props.$gutter, function (cssValue, breakpoint) {
      // horizontally centered require -50%
      var x = props.$centerHorizontally ? "-50%" : '0';
      var value = props.$opened ? "translate3d(".concat(x, ", 0, 0)") : "translate3d(".concat(x, ", ").concat(props.$floatPosition.top !== undefined ? "calc(-".concat(cssValueToString(props.$calculatedHeight), " - ").concat(cssValueToString(cssValue), ")") : "calc(".concat(cssValueToString(props.$calculatedHeight), " + ").concat(cssValueToString(cssValue), ")"), ", 0)");
      return generateBoxPropStyleRow('transform')(value, breakpoint);
    }).join('\n');
  }
}, boxStyles);

export { FloatWrapper };
